import {
  MenuItem,
} from '@material-ui/core';
/* eslint-disable no-nested-ternary */
import Grid from '@material-ui/core/Grid';
import {
  getDegree,
  getSchoolFormations,
  getTrainingDomains,
  getTrainingType,
} from '@webapps/business';
import {
  Pagination,
  PaginationNumbers,
  TextField,
  useAuth,
  useQuery,
  useRouter,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { useEffect, useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import CardFormation from './CardFormation';

const Formation = () => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const { idUser } = useAuth();
  const { params } = useRouter();
  const { id: idParam } = params;

  const [page, setPage] = useState(1);
  const [trainingType, setTrainingType] = useState('');
  const [trainingDomain, setTrainingDomain] = useState('');
  const [degree, setDegree] = useState('');

  const searchTrainingDomains = (e) => {
    const newValue = e.target.value === 'all' ? '' : e.target.value;
    setTrainingDomain(newValue);
    setPage(1);
  };

  const searchTrainingType = (e) => {
    const newValue = e.target.value === 'all' ? '' : e.target.value;
    setTrainingType(newValue);
    setPage(1);
  };

  const searchDegree = (e) => {
    const newValue = e.target.value === 'all' ? '' : e.target.value;
    setDegree(newValue);
    setPage(1);
  };

  const {
    data: { content: trainingDomains = [] } = {},
    isLoading: trainingDomainsLoading,
  } = useQuery(getTrainingDomains, {
    key: 'trainingDomainsMap',
  });

  const { data: trainingTypes = [] } = useQuery(getTrainingType, {
    key: 'trainingTypeMap',
  });

  const { data: degrees = [] } = useQuery(getDegree, {
    key: 'degreeMap',
  });

  const [size, setSize] = useState(window.innerWidth < 768 ? 3 : 4);

  const {
    status: load,
    data: { content: formations = [], totalElements } = {},
    isFetching,
    refetch,
  } = useQuery(getSchoolFormations, {
    key: ['formations', page, trainingDomain, trainingType, degree],
    variables: {
      id: typeof idParam !== 'undefined' ? idParam : idUser,
      domain: trainingDomain,
      trainingType: trainingType,
      degree: degree,
      page: page - 1,
      size,
    },
    keepPreviousData: true,
    staleTime: 5000,
  });

  const [scroll, setScroll] = useState(false);

  const handleScroll = (e) => {
    if (scroll) return;
    const { scrollHeight, scrollTop, clientHeight } = e.target;
    const scrollPercentage = (scrollTop / (scrollHeight - clientHeight)) * 100;
    if (scrollPercentage >= 80) {
      setScroll(true);
    }
  };

  useEffect(() => {
    if (scroll) {
      if (totalElements <= size) {
        return;
      }
      setSize(size + 4);
      setTimeout(() => {
        setScroll(false);
        refetch();
      }, 200);
    }
  }
    , [scroll]);

  const filteredFormations = useMemo(() => {
    return formations.filter((f) => {
      const domainMatches =
        !trainingDomain || (f.domain && f.domain.id === trainingDomain);
      const typeMatches =
        !trainingType || (f.trainingType && f.trainingType.id === trainingType);
      const degreeMatches = !degree || (f.degree && f.degree.id === degree);
      return domainMatches && typeMatches && degreeMatches;
    });
  }, [formations, trainingDomain, trainingType, degree]);


  return (
    <div className={classes.container}>
      <div className={cx(global.title, classes.title)}>
        Nos formations
      </div>
      <div className={classes.formations}>
        <div className={classes.offersDiv}>
          <Grid
            container
            className={css({
              '@media (max-width:768px)': {
                flexDirection: 'column',
              },
            })}
            spacing={1}
          >
            <Grid item xs={12} md={4}>
              <TextField
                borderRadius={400}
                fullWidth
                label="Domaine d'étude "
                name="domains"
                onChange={(e) => searchTrainingDomains(e)}
                select
              >
                <MenuItem value="all">
                  Tous les domaines
                </MenuItem>
                {trainingDomains.map(({ id, label }, index) => (
                  <MenuItem
                    key={index}
                    value={id}
                  >
                    {label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                borderRadius={400}
                label="Type de formation"
                name="trainingType"
                onChange={(e) => searchTrainingType(e)}
                select
              >
                <MenuItem value="all" className={classes.menuItem}>
                  Tous les types de formation
                </MenuItem>
                {trainingTypes.map(({ id, label }, index) => (
                  <MenuItem key={index} className={classes.menuItem} value={id}>
                    {label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="Niveau d'étude"
                name="degree"
                borderRadius={400}
                onChange={(e) => searchDegree(e)}
                select
              >
                <MenuItem value="all" className={classes.menuItem}>
                  Tous les niveaux
                </MenuItem>
                {degrees.map(({ id, label }, index) => (
                  <MenuItem key={index} className={classes.menuItem} value={id}>
                    {label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
        </div>
      </div>
      <div>
        <div className={classes.formations}></div>
        {filteredFormations?.length === 0 ? (
          <div
            className={css({
              textAlign: 'center',
              color: '#5D75A8',
              padding: 20,
            })}
          >
            <FormattedMessage id="noElements" />
          </div>
        ) : (
          <Grid
            container
            direction="column"
            className={css({
              backgroundColor: '#F3F7FF',
              marginTop: spacing(2),
              padding: spacing(2),
              borderRadius: 10,
              maxHeight: '225px',
              '@media only screen and (max-width: 768px)': {
                height: 'auto',
                overflowX: 'hidden',
                maxHeight: 'none',
              },
            })}
          >
            <div
              className={css({
                flexDirection: 'row',
                display: 'flex',
                gap: 16,
                paddingRight: filteredFormations?.length > 2 ? spacing(2) : 0,
                overflowX: 'hidden',
                flexWrap: 'wrap',
                '&::-webkit-scrollbar': {
                  backgroundColor: '#F3F7FF',
                },
                '&::-webkit-scrollbar-thumb': {
                  backgroundColor: '#0060F9',
                },
                '&::-webkit-scrollbar-track': {
                  backgroundColor: '#C0D9FF',
                },
                '@media only screen and (max-width: 768px)': { overflow: 'hidden', padding: 0 },
              })}
              onScroll={(e) => handleScroll(e)}
            >
              {filteredFormations?.map((item, index) => (
                <CardFormation
                  address={item?.address}
                  contrat={item?.trainingType}
                  createdAt={item?.createdAt}
                  item={item}
                  name={item?.label}
                  typeFormation={item?.degree}
                />
              ))}
            </div>
          </Grid>
        )}
      </div>
      <div className={classes.pagination}>
        <PaginationNumbers
          onChange={(newPage) => setPage(newPage)}
          page={page}
          pageCount={size}
          totalCount={totalElements}
        />
      </div>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    backgroundColor: 'white',
    borderRadius: 10,
    padding: spacing(2.5),
    marginBottom: 25,
    '@media screen and (max-width: 768px)': {
      marginBottom: 20,
    },
  },
  pagination: {
    '@media screen and (min-width: 768px)': {
      display: 'none',
    }
  },
  title: {
    borderLeft: '3px solid #0060F9',
    paddingLeft: 8,
    marginBottom: spacing(2),
    fontWeight: 600,
    width: '100%',
  },
  offersDiv: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  formations: {
    display: 'flex',
    width: '100%',
  },
});

export default Formation;
